import { Component, OnInit, ViewChild, TemplateRef, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { DataTablesResponse } from '../../shared/models/datatables-response';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AuthenticationService } from '../../shared/auth/authentication.service';
import { EmailValidator, ValidationService } from '../../shared/providers/validation.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Subject, Subscription } from 'rxjs';
import { Router, ActivatedRoute, Params } from '@angular/router';
enum PortfolioTabs {
  Access = 1,
  NoAccess = 2,
}

@Component({
  selector: 'app-view-portfolio',
  templateUrl: './view-portfolio.component.html',
  styleUrls: ['./view-portfolio.component.css']
})
export class ViewPortfolioComponent implements OnInit, OnDestroy {
  userId: number = 0;
  private _subscriptions: Subscription[] = [];
  @Input() IsPDeleted: boolean = false;
  dealContacts = [];
  searchText = "";
  modalRef: BsModalRef;
  table: DataTableDirective;
  modalRefDelete: BsModalRef;
  deleteId = 0;
  filterData: any;
  portfolioTabs = PortfolioTabs;
  activePortfolioTab = PortfolioTabs.Access;
  dtOptions = {};
  dtTrigger = new Subject();
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  protected readonly BASE_URL: string = environment.base_url;
  IsLoading = false;
  //defaultContactText: IMultiSelectTexts = {
  //  defaultTitle: 'Filter By Category',
  //};
  defaultTypeSettings = {
    dynamicTitleMaxItems: 1,
  };
  constructor(private http: HttpClient,public _ValidationService: ValidationService, public authService: AuthenticationService, private router: Router) { }

  ngOnInit() {
    let user: any;
    user = this.authService.user;
    this.userId = user.Id;
    this.getPortfolioList();
  }

  ngOnDestroy() {
    this._subscriptions.forEach(sub => sub.unsubscribe());
  }

  getPortfolioList() {

    const that = this;
    
    this.dtOptions = {
      pagingType: 'full_numbers',
      serverSide: true,
      processing: true,
      info: false,
      search: true,
      ordering: true,
      seaching: true,
      paging: true,
      "pageLength": 50,
      language: {
        zeroRecords: null,
        processing: `<div class="custom-dt-loader">
        <div class="circle-loader-wrapper">
          <div class="circle-loader-ring"></div>
          <img src="assets/img/logos/logo.png" class="loader-icon" />
        </div>
      </div>
     `,
      },
      "order": [[1, "desc"]],
      bLengthChange: false,
      initComplete: () => $('.dataTables_filter').css('display', 'none'),
      ajax: (dataTablesParameters: any, callback: Function) => {
        this.IsLoading = true;
        dataTablesParameters.Extra_param = {
          SearchText: this.searchText,
          PortfolioActiveTab: this.activePortfolioTab == this.portfolioTabs.Access?1:0
        }

        const httpHeader = this._ValidationService.GetAuthHeader();
        this._subscriptions.push(that.http.post<DataTablesResponse>(
          this.BASE_URL + '/dataentryproperty/getallportfolio', dataTablesParameters, httpHeader).subscribe(resp => {
            that.dealContacts = resp.data ? resp.data : [];
            that.filterData = resp.data ? resp.data : [];
            if (resp) {
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: []
              });
              if (resp.data.length === 0) {
                $(".dataTables_paginate.paging_full_numbers").hide();
              }
              else {
                $(".dataTables_paginate.paging_full_numbers").show();
              }
              $(".paginate_button.first,.paginate_button.last").hide();
            } else {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
            }
            $(".paginate_button.first,.paginate_button.last").hide();
            this.IsLoading = false;
          }));
      },
      columns: [
        { data: 'Name' },
        { data: 'Portfolio' },
        { data: 'Company' },
        { data: 'Role' },
        { data: 'Properties' }],
    };
  }
 
  ngAfterViewInit(): void {
    this.dtTrigger.next(true);
  }
  
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    //this.dealContacts.filter = filterValue;
  }

  search(text: string) {
    this.dtElement.dtInstance.then(x => x.draw(false));
  }

  redirectOnCellClick(userGuid:string) {
    if (userGuid != null) {
      this.router.navigateByUrl('/market-snapshot?UserGuid=' + userGuid+'&opentab=1');
    }
  }

  redrawTable() {
    this.dtElement.dtInstance.then(x => x.draw(false));
  }

  onPortfolioTabClick(tab) {
    this.activePortfolioTab = tab;
    this.dtElement.dtInstance.then(x => x.draw());
  }
}
